import FadSDK from "@fad-producto/fad-sdk";
import { useEffect } from "react";
import useAuth from "../../../context/auth";
import { useNavigate } from "react-router-dom";

export const Signature = () => {
    const { user } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        const initProcess = async () => {
            const options = {
                environment: FadSDK.getFadEnvironments().PROD
            };

            console.log(`V${FadSDK.version}`)
            //@ts-ignore
            const FAD_SDK = new FadSDK(null, options);
            try {
                const ticket = user?.actualContract?.contract?.integrations?.sign?.ticket as string
                const result = await FAD_SDK.startFadWeb4(ticket);
                console.log(result);
                navigate("/cliente", {
                    state: {
                        hasSigned: true
                    }
                })
            } catch (ex) {
                // PRROCESS_ERROR
                console.log('Unexpected error: ', ex);
                // window.location.reload()

            } finally {
                FAD_SDK.end();
            }
        }

        initProcess()
    }, [])

    return (
        <></>
    )

}